exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tinymce-container[data-v-0177f75c] {\r\n  position: relative;\r\n  line-height: normal;\n}\n.tinymce-container[data-v-0177f75c] .mce-fullscreen {\r\n  z-index: 10000;\n}\n.tinymce-textarea[data-v-0177f75c] {\r\n  visibility: hidden;\r\n  z-index: -1;\n}\n.editor-custom-btn-container[data-v-0177f75c] {\r\n  position: absolute;\r\n  right: 4px;\r\n  top: 4px;\r\n  /*z-index: 2005;*/\n}\n.fullscreen .editor-custom-btn-container[data-v-0177f75c] {\r\n  z-index: 10000;\r\n  position: fixed;\n}\n.editor-upload-btn[data-v-0177f75c] {\r\n  display: inline-block;\n}\r\n", ""]);

// exports
